import { initializeApp } from 'firebase/app'
import {getFirestore} from 'firebase/firestore'
import {getFunctions} from 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyC6VRCeJBVsKMUoA0LkKqTqlR0swqJPK_E",
    authDomain: "rentals.rajnaini.com",
    databaseURL: "http://127.0.0.1:4000/firestore ",
    projectId: "rajnaini-rental-analytics",
    storageBucket: "rajnaini-rental-analytics.appspot.com",
    messagingSenderId: "741596316125",
    appId: "1:741596316125:web:4b1fca5de2ebce87d1f634",
    measurementId: "G-T9C0VQMP08"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);